/* eslint-disable array-callback-return */
export const flattenVendorContacts = (contacts) => {
    let flattenedContacts = [];
    if (contacts && contacts.length > 0) {
        contacts.map(c => {
            flattenedContacts.push({
                contactId: c.contact.contactId,
                prefix: c.contact.prefix,
                firstName: c.contact.firstName,
                lastName: c.contact.lastName,
                phoneNumber: c.contact.phoneNumber,
                email: c.contact.email,
                description: c.contact.description,
                jobTitle: c.contact.jobTitle,
                isPrimary: c.contact.isPrimary,
                addressLine1: c.contactAddress.addressLine1,
                addressLine2: c.contactAddress.addressLine2,
                addressLine3: c.contactAddress.addressLine3,
                city: c.contactAddress.city,
                county: c.contactAddress.county,
                countryId: c.contactAddress.countryId,
                provinceId: c.contactAddress.provinceId,
                zipcode: c.contactAddress.zipcode
            })
        });
    }
    return flattenedContacts;

}

export const flattenBanks = (banks) => {
    let flattenedBanks = [];
    if (banks && banks.length !== 0) {
        banks.map(c => {
            flattenedBanks.push({
                vendorBankId: c.vendorBank.vendorBankId,
                vendorId: c.vendorBank.vendorId,
                bankId: c.vendorBank.bankId,
                paymentCode: c.vendorBank.paymentCode,
                transitCode: c.vendorBank.transitCode,
                cuitCode: c.vendorBank.cuitCode,
                institutionNumber: c.vendorBank.institutionNumber,
                statusId: c.bank.statusId,
                accountLocationId: c.bank.accountLocationId,
                accountTypeId: c.bank.accountTypeId,
                bankName: c.bank.bankName,
                bankCity: c.bank.bankCity,
                bankPostal: c.bank.bankPostal,
                bankProvinceId: c.bank.bankProvinceId,
                bankCountryId: c.bank.bankCountryId,
                accountHolderName: c.bank.accountHolderName,
                accountHolderAddressId: c.bank.accountHolderAddressId,
                bankPhone: c.bank.bankPhone,
                bankFax: c.bank.bankFax,
                bankEmail: c.bank.bankEmail,
                bankWebsite: c.bank.bankWebsite,
                bankContactName: c.bank.bankContactName,
                bankSwiftCode: c.bank.bankSwiftCode,
                routingNumber: c.bank.routingNumber,
                accountNumber: c.bank.accountNumber,
                accountCurrencyId: c.bank.accountCurrencyId,
                ibanNumber: c.bank.ibanNumber,
                clabe: c.bank.clabe,
                isDefaultAccount: c.bank.isDefaultAccount,
                isPreferredForWire: c.bank.isPreferredForWire,
                wireInstruction: c.bank.wireInstruction,
                isPreferredForACH: c.bank.isPreferredForACH,
                hasIntermedReqd: c.bank.hasIntermedReqd,
                intermedBankingId: c.bank.intermedBankingId,
                specialInstructions: c.bank.specialInstructions,
                bankNickName: c.bank.bankNickName,
                paymentTypeId: c.bank.paymentTypeId,
                acumaticaLocationId: c.bank.acumaticaLocationId,
                isPaymentByDueDate: c.bank.isPaymentByDueDate,
                isPaymentByDiscountRate: c.bank.isPaymentByDiscountRate,
                intermediaryBankName: c.bank.intermediaryBankName,
                intermediarySwiftCode: c.bank.intermediarySwiftCode,
            })
        });
        return flattenedBanks;
    }
    else {
        return flattenedBanks;
    }

}